
import { useMainPageConfig } from '@entities/MainPageConfig'
import { PreviewStories } from '@entities/Stories'

import { CartPreview } from '@features/cart'
import { MainPageBuilder } from '@features/main-page-builder'

import useStickyHeader from '@widgets/header/hook/useStickyHeader'




import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import Wrapper from '@shared/ui/wrapper'

// import { BlogPreview } from "@widgets/blog-preview";
import styles from './MainPage.module.scss'

export default function MainPage () {
  const { mainPageConfig } = useMainPageConfig()

  const { observerRef, showStickyHeader, StickyHeader } = useStickyHeader()

  return (
    <div className={styles.root}>
      <Container>
        <PageGrid aside={<CartPreview />}>
          <Wrapper
            style={{
              overflow: 'initial',
              position: 'relative'
            }}
          >
            <PreviewStories />
            { showStickyHeader && <StickyHeader /> }
            <div ref={observerRef} />
            <MainPageBuilder blocks={mainPageConfig?.blocks} />
            {/* <BannerApp /> */}
          </Wrapper>
        </PageGrid>
      </Container>
    </div>
  )
}